import { FunctionComponent } from 'react'
import { useBrowserService } from '../hooks'
import { configureLoggerAndConsoleOnClient, configureLoggerAndConsoleOnServer } from '../tracking/felog/telemetry'
import { feMetrics } from '../tracking/metrics'
import { BasePageProps } from './with-services'

const rootLoggerName = 'cms'

export const withTelemetry = <T extends BasePageProps>(Component: FunctionComponent<T>): FunctionComponent<T> => {
  if (!IS_CLIENT_SIDE) {
    configureLoggerAndConsoleOnServer(rootLoggerName)
    feMetrics.initOnServer()
  }

  return (pageProps) => {
    const browserService = useBrowserService()
    if (IS_CLIENT_SIDE) {
      configureLoggerAndConsoleOnClient(rootLoggerName)
      feMetrics.initOnClient(browserService)
    }

    return <Component {...(pageProps as T)} />
  }
}
